import { render, staticRenderFns } from "./new-quotation.vue?vue&type=template&id=0ce1a0b8"
import script from "./new-quotation.vue?vue&type=script&lang=js"
export * from "./new-quotation.vue?vue&type=script&lang=js"
import style0 from "./new-quotation.vue?vue&type=style&index=0&id=0ce1a0b8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports